'use strict';

angular.module('DoohApps').filter('cssVersionFilter', ['DoohConfig', 'Constants', function (DoohConfig, Constants) {
    return function (link) {

        if (!DoohConfig.isDebugMode)
            link = link.replace('CSS/', 'CSS/min/').replace('.css', '.min.css');
        link += '?v=' + DoohConfig.version;
        return link;
    }
}]);